import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');

class PlasmaticDeliveryStats extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.handleTypeAheadChange = this.handleTypeAheadChange.bind(this);
		this.setTable = this.setTable.bind(this);

		var aux_date = new Date();
		this.state = {
			start_date 	:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			listado:[],
			columns:[
				{title:'Producto'},
				{title:'Total'}
			],
			product:"",
			products:[],
			file_name:"Estadística de productos enviados",
			loading_prod:false,
			index_prod:-1,
			product_selected:[],
			date_hour:"",
            medical:"",
            totales:""
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		$('.rt-menu').css('width', '270px !important');
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product?option=actives', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
                response.unshift({id:'all', name:'TODOS'})

				this.setState({
					products: response,
                });
                
                this.handleTypeAheadChange(response)
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})


		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			order: [[1, 'asc']],
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.file_name
            	},
            	{
                	extend: 'pdfHtml5',
                	exportOptions:{
                		columns: ':visible'
                	},
                	title: this.state.file_name,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] })

                		doc.defaultStyle.fontSize = 6.5;
                		doc.styles.tableHeader.fontSize = 6.5;   

                        doc.content[3].table.widths=["80%","20%"];
                        doc.content.push({text: 'Total: '+this.state.totales, margin:[10,0,0,10]})

                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			ordering:false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'lote'){
			if(e.target.value.length <= 50){
				this.setState({
					[e.target.name]: e.target.value
				});
			}
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}
		

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
			//if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					product_id:this.state.product,
					health_facilities_id:sessionStorage.getItem('health_facilities_id')
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/product_export_stats',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){

						this.setState({
							listado: []
						});

						
                        var list = [];
                        
                        response.resp.map((res)=>{
                            return  list.push([
                                res.product,
                                res.total
                            ]);
                        });
							
						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);


						this.setState({
                            listado: list,
                            totales: response.total
						});
						
					}
				});
			/*}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}*/
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	handleTypeAheadChange(values){

        if(values.length > 0){
    		this.setState({loading_prod:true});

    		setTimeout(()=>{
    			/*this.setState({
					loading_patient:false,
					patient:values[0].id,
			    });*/

			    setTimeout(()=>{
        			this.setState({
						index_prod:0,
						product_selected:values,
						loading_prod:false,
						product:values[0].id,
				    });

				    //this.errorAutoComplete('product');
        		}, 1000);

    		}, 1000);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Productos Hemostáticos ->
					{this.state.file_name}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_plasmatic_prod"} 
		            submenu={"help_product_export_stats"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>


								<div className="form-group">
									<span className="span-min">Producto</span>
									<Typeahead
							          	labelKey={(option) => (`${option.name}`)}
							          	minLength={3}
							          	options={this.state.products.length > 0 ? this.state.products : []}
							          	onChange={this.handleTypeAheadChange}	
							            inputProps={{
							          		name:"product_id",
							          		id:"product_id",
							          		autoComplete:"off",
							          		required:true,
							          		
							          	}}
							          	className="product-report"
							          	id="autp_prod"
							          	isLoading={this.state.loading_prod}
							          	useCache={false}
							          	ref={ref => this._typeahead_patient = ref}
							          	selected={this.state.product_selected}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
                                    {console.log(this.state.product_selected)}
							        {/*<select id="product" name="product" value={this.state.product}
							        	onChange={this.handleChange} className="form-control" required>
							        	<option value="">Seleccione...</option>
							        	{this.state.products.map((p, i)=>(
							        		<option key={i} value={p.id}>
							        			{p.name}
							        		</option>
							        	))}
							        </select>*/}
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} 
										style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.file_name}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>

								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12">
                                    Total: <span>{this.state.totales}</span>
                                </div>
							</div>

								
						</form>
					</div>
				</div>

			</div>
		)
	}
}

export default translate('translations') (PlasmaticDeliveryStats);